import {
  CreateItemCacheKeys,
  CreateItemGqlQuery,
  CreatedAt,
  DateFilterType,
  DeleteItemCacheKeys,
  DeleteItemGqlQuery,
  FetchItemCacheKey,
  FetchItemGqlQuery,
  FetchItemsCacheKey,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsSort,
  ID,
  IdFilterType,
  NanoID,
  TextFilterType,
  UUID,
  UpdateItemCacheKeys,
  UpdateItemGqlQuery,
  UpdatedAt
} from '../../types';
import { UserID, UserNanoID } from '../users/usersTypes';

export type CompanyTabID = ID;
export type CompanyTabUUID = UUID;
export type CompanyTabNanoID = NanoID;
export type CompanyTabName = string;
export type CompanyTabContent = string;
export type CompanyTabPosition = number;
export type CompanyTabType = string;
export type CompanyTabCreatedAt = CreatedAt;
export type CompanyTabUpdatedAt = UpdatedAt;
export type CompanyTabUserID = UserID;
export type CompanyTabCompanyID = ID;

export interface CompanyTabUser {
  id: UserID;
  nanoId: UserNanoID;
}

export const enum FetchCompanyTabsSortTypes {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  UUID_ASC = 'UUID_ASC',
  UUID_DESC = 'UUID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  POSITION_ASC = 'POSITION_ASC',
  POSITION_DESC = 'POSITION_DESC',
  COMPANY_ID_ASC = 'COMPANY_ID_ASC',
  COMPANY_ID_DESC = 'COMPANY_ID_DESC'
}

export interface FetchCompanyTabsFilters {
  id?: IdFilterType;
  createdAt?: DateFilterType;
  updatedAt?: DateFilterType;
  name?: TextFilterType;
  companyId?: IdFilterType;
}

export type FetchCompanyTabsGqlQuery = FetchItemsGqlQuery;
export type FetchCompanyTabsCacheKey = FetchItemsCacheKey;
export type FetchCompanyTabsSort = FetchItemsSort;
export type FetchCompanyTabsPage = FetchItemsPage;
export type FetchCompanyTabsLimit = FetchItemsLimit;

export type FetchCompanyTabGqlQuery = FetchItemGqlQuery;
export type FetchCompanyTabCacheKey = FetchItemCacheKey;

export type CreateCompanyTabGqlQuery = CreateItemGqlQuery;
export type CreateCompanyTabCacheKeys = CreateItemCacheKeys;

export type UpdateCompanyTabGqlQuery = UpdateItemGqlQuery;
export type UpdateCompanyTabCacheKeys = UpdateItemCacheKeys;

export type DeleteCompanyTabGqlQuery = DeleteItemGqlQuery;
export type DeleteCompanyTabCacheKeys = DeleteItemCacheKeys;
